export const en = {
  toggleTheme: 'Toggle theme',
  light: 'Light',
  dark: 'Dark',
  system: 'System',
  settings: 'Settings',
  warning: 'Warning',
  ourAutomatedChecksIndicateThatThisDocumentIsValid:
    'Our automated checks indicate that this document is valid and contains no issues.',
  ourAutomatedChecksHaveDetectedIssuesWithThisDocument:
    'Our automated checks have detected issues with this document.',
  youHaveAlreadyEnteredSomeInformationForThisPerson:
    'You have already entered some information for this person.',
  dismissingThisSignalWillRemoveItFromCurrentRisk:
    'Dismissing this signal will remove it from current risk calculations and update the risk accordingly.',
  ravenApi: 'Raven API',
  admin: 'Admin',
  organizations: 'Organizations',
  createOrganization: 'Create Organization',
  owners: 'Owners',
  officers: 'Officers',
  inviteOfficer: 'Invite Officer',
  clients: 'Clients',
  clientProfile: 'Client Profile',
  bookmarks: 'Bookmarks',
  notifications: 'Notifications',
  reports: 'Reports',
  createReport: 'Create report',
  reportWizard: 'Report wizard',
  reportPage: 'Report Page',
  apiTokens: 'API Tokens',
  twoFactorAuthentication: 'Two Factor Authentication',
  passkey: 'Passkey',
  appearances: 'Appearances',
  unsavedChanges: 'Unsaved changes',
  sessionNotFoundUserIsNotAuthenticated: 'Session not found. User is not authenticated.',
  tokenDeleted: 'Token deleted',
  theTokenWasDeletedSuccessfully: 'The token was deleted successfully.',
  anUnknownErrorOccurred: 'An unknown error occurred',
  weEncounteredAnUnknownErrorWhileAttemptingToDelete:
    'We encountered an unknown error while attempting to delete this token. Please try again later.',
  delete: 'Delete',
  areYouSureYouWantToDeleteThisToken: 'Are you sure you want to delete this token?',
  pleaseNoteThatThisActionIsIrreversibleOnceConfirmed:
    'Please note that this action is irreversible. Once confirmed, your token will be permanently deleted.',
  confirmByTyping: 'Confirm by typing:',
  iMSureDeleteIt: "I'm sure! Delete it",
  successfullyCreatedPasskey: 'Successfully created passkey',
  addPasskey: 'Add passkey',
  passkeysAllowYouToSignInAndAuthenticateUsing:
    'Passkeys allow you to sign in and authenticate using biometrics, password managers, etc.',
  passkeyName: 'Passkey name',
  egMac: 'eg. Mac',
  whenYouClickContinueYouWillBePromptedTo:
    'When you click continue, you will be prompted to add the first available authenticator on your system.',
  ifYouDoNotWantToUseTheAuthenticator:
    'If you do not want to use the authenticator prompted, you can close it, which will then display the next available authenticator.',
  thisPasskeyHasAlreadyBeenRegistered: 'This passkey has already been registered.',
  youCannotHaveMoreThan: 'You cannot have more than',
  passkeys: 'passkeys.',
  passkeyCreationCancelledDueToOneOfTheFollowing:
    'Passkey creation cancelled due to one of the following reasons:',
  cancelledByUser: 'Cancelled by user',
  passkeyAlreadyExistsForTheProvidedAuthenticator:
    'Passkey already exists for the provided authenticator',
  exceededTimeout: 'Exceeded timeout',
  somethingWentWrongPleaseTryAgainOrContactSupport:
    'Something went wrong. Please try again or contact support.',
  '404NotFound': '404 not found',
  oopsSomethingWentWrong: 'Oops! Something went wrong.',
  thePageYouAreLookingForWasMovedRemoved:
    'The page you are looking for was moved, removed, renamed or might never have existed.',
  '500InternalServerError': '500 Internal Server Error',
  anUnexpectedErrorOccurred: 'An unexpected error occurred.',
  goBack: 'Go Back',
  home: 'Home',
  dashboard: 'Dashboard',
  allReports: 'All Reports',
  raven: 'Raven',
  smartKycPlatform: 'Smart KYC Platform',
  logOut: 'Log Out',
  searchByClientName: 'Search by Client Name…',
  sortBy: 'Sort By',
  submissionDate: 'Submission Date',
  lastReview: 'Last Review',
  order: 'Order',
  descending: '↓ Descending',
  ascending: '↑ Ascending',
  sort: 'Sort',
  filter: 'Filter',
  riskLevelJustification: 'Risk Level Justification',
  breakdownOfRiskFactors: 'Breakdown of Risk Factors',
  relativeContributionOfEvidenceToTheAssessment:
    'Relative contribution of evidence to the assessment',
  riskEvidenceContributionChart: 'Risk evidence contribution chart',
  high3UnitsMedium1InformationalAndDismissed0:
    'High = 3 units; Medium = 1. Informational and dismissed = 0. Percentages describe evidence, not probabilities.',
  noContributingRiskEvidenceRecordedNoPercentageHasBeen:
    'No contributing risk evidence recorded. No percentage has been inferred.',
  whyThisRiskLevel: 'Why This Risk Level?',
  provisionalOfficerReviewRequired: 'Provisional · officer review required',
  reviewedAssessment: 'Reviewed assessment',
  reviewedFindings: '◦ Reviewed findings:',
  companyAndMemberExposureUseTheHighestSupportedSeverity:
    '◦ Company and member exposure use the highest supported severity.',
  researchCompleted: 'Research completed.',
  someResearchCoverageIsInsufficientAcceptanceRemainsUnavailable:
    'Some research coverage is insufficient. Acceptance remains unavailable.',
  policy: 'Policy',
  publicWebResearch: '· Public web research',
  riskLevel: 'Risk Level:',
  notes: 'Notes',
  addYourNote: 'Add Your Note',
  addedBy: 'Added by',
  on: 'on',
  deleteNote: 'Delete note',
  newNote: 'New note',
  addAnything: 'Add anything…',
  save: 'Save',
  monthlyTotals: 'Monthly totals',
  noDataInThisPeriod: 'No data in this period.',
  viewChartData: 'View chart data',
  reportRisksOverTimeSelectAPointToInspect:
    'Report risks over time; select a point to inspect its signals',
  report: 'Report',
  noGeneratedReportsYet: 'No generated reports yet',
  weCouldnTLoadThisInformation: 'We couldn’t load this information.',
  tryAgain: 'Try again',
  loading: 'Loading…',
  previous: '‹ Previous',
  next: 'Next ›',
  errorLoadingClients: 'Error loading clients',
  tryAgain2: 'Try Again',
  errorLoadingOwners: 'Error loading owners',
  name: 'Name',
  createdAt: 'Created At',
  searchOrganizationsByNameCountryOrOwner: 'Search organizations by name, country, or owner...',
  clearFilters: 'Clear Filters',
  errorLoadingOrganizations: 'Error loading organizations',
  inactive: 'Inactive',
  active: 'Active',
  noOfficersFound: 'No officers found',
  noOfficersMatchYourSearchCriteria: 'No officers match your search criteria.',
  thereAreNoOfficersInYourOrganizationYet: 'There are no officers in your organization yet.',
  invitationResent: 'Invitation resent',
  aNewInvitationEmailHasBeenSentToThe: 'A new invitation email has been sent to the member.',
  failedToResendInvitation: 'Failed to resend invitation',
  resendInvitationEmail: 'Resend invitation email',
  resend: 'Resend',
  searchClientsByNameTypeIdOfficerOrRisk:
    'Search clients by name, type, ID, officer, or risk level...',
  organizationName: 'Organization Name',
  owner: 'Owner',
  accountStatus: 'Account Status',
  searchOfficersByNameOrEmail: 'Search officers by name or email...',
  role: 'Role',
  allRoles: 'All Roles',
  managerOfficer: 'Manager Officer',
  officer: 'Officer',
  kybOfficer: 'KYB Officer',
  kycOfficer: 'KYC Officer',
  searchOwnersByNameEmailOrOrganization: 'Search owners by name, email, or organization...',
  success: 'Success',
  passkeyHasBeenUpdated: 'Passkey has been updated',
  weAreUnableToUpdateThisPasskeyAtThe:
    'We are unable to update this passkey at the moment. Please try again later.',
  passkeyHasBeenRemoved: 'Passkey has been removed',
  weAreUnableToRemoveThisPasskeyAtThe:
    'We are unable to remove this passkey at the moment. Please try again later.',
  edit: 'Edit',
  updatePasskey: 'Update passkey',
  youAreCurrentlyUpdatingThe: 'You are currently updating the',
  passkey2: 'passkey.',
  update: 'Update',
  deletePasskey: 'Delete passkey',
  areYouSureYouWantToRemoveThe: 'Are you sure you want to remove the',
  passkey3: 'passkey?',
  pendingInvitation: 'Pending Invitation',
  errorLoadingOfficers: 'Error loading officers',
  ownerName: 'Owner Name',
  organization: 'Organization',
  noOwnersFound: 'No owners found',
  noOwnersMatchYourSearchCriteria: 'No owners match your search criteria.',
  thereAreNoOrganizationOwnersInTheSystemYet: 'There are no organization owners in the system yet.',
  noClientsFound: 'No clients found',
  noClientsMatchYourSearchCriteria: 'No clients match your search criteria.',
  thereAreNoClientsAvailableAtTheMoment: 'There are no clients available at the moment.',
  noOrganizationsFound: 'No organizations found',
  noOrganizationsMatchYourSearchCriteria: 'No organizations match your search criteria.',
  thereAreNoOrganizationsInTheSystemYet: 'There are no organizations in the system yet.',
  created: 'Created',
  lastUsed: 'Last used',
} as const;
export const fa: Record<keyof typeof en, string> = {
  toggleTheme: 'تغییر پوسته',
  light: 'روشن',
  dark: 'تیره',
  system: 'مطابق دستگاه',
  settings: 'تنظیمات',
  warning: 'هشدار',
  ourAutomatedChecksIndicateThatThisDocumentIsValid: 'در بررسی خودکار این مدرک، مشکلی شناسایی نشد.',
  ourAutomatedChecksHaveDetectedIssuesWithThisDocument:
    'در بررسی خودکار این مدرک، مواردی شناسایی شده است.',
  youHaveAlreadyEnteredSomeInformationForThisPerson: 'قبلاً اطلاعاتی برای این شخص وارد کرده‌اید.',
  dismissingThisSignalWillRemoveItFromCurrentRisk:
    'با رد این مورد، اثر آن از محاسبه ریسک حذف و میزان ریسک به‌روزرسانی می‌شود.',
  ravenApi: 'Raven API',
  admin: 'مدیریت',
  organizations: 'سازمان‌ها',
  createOrganization: 'ایجاد سازمان',
  owners: 'مالکان',
  officers: 'کارشناسان',
  inviteOfficer: 'دعوت کارشناس',
  clients: 'مشتریان',
  clientProfile: 'پرونده مشتری',
  bookmarks: 'نشان‌شده‌ها',
  notifications: 'اعلان‌ها',
  reports: 'گزارش‌ها',
  createReport: 'ایجاد گزارش',
  reportWizard: 'مراحل تهیه گزارش',
  reportPage: 'صفحه گزارش',
  apiTokens: 'کلیدهای API',
  twoFactorAuthentication: 'احراز هویت دومرحله‌ای',
  passkey: 'کلید عبور',
  appearances: 'ظاهر برنامه',
  unsavedChanges: 'تغییرات ذخیره‌نشده',
  sessionNotFoundUserIsNotAuthenticated: 'برای ادامه وارد حساب خود شوید.',
  tokenDeleted: 'کلید حذف شد',
  theTokenWasDeletedSuccessfully: 'کلید با موفقیت حذف شد.',
  anUnknownErrorOccurred: 'خطای پیش‌بینی‌نشده‌ای رخ داد',
  weEncounteredAnUnknownErrorWhileAttemptingToDelete:
    'حذف کلید انجام نشد. لطفاً کمی بعد دوباره تلاش کنید.',
  delete: 'حذف',
  areYouSureYouWantToDeleteThisToken: 'این کلید حذف شود؟',
  pleaseNoteThatThisActionIsIrreversibleOnceConfirmed:
    'با تأیید، کلید برای همیشه حذف می‌شود. این کار قابل بازگشت نیست.',
  confirmByTyping: 'برای تأیید بنویسید:',
  iMSureDeleteIt: 'تأیید و حذف',
  successfullyCreatedPasskey: 'کلید عبور ایجاد شد',
  addPasskey: 'افزودن کلید عبور',
  passkeysAllowYouToSignInAndAuthenticateUsing:
    'با کلید عبور می‌توانید از اثر انگشت، تشخیص چهره یا برنامه مدیریت رمز عبور برای ورود استفاده کنید.',
  passkeyName: 'نام کلید عبور',
  egMac: 'مثلاً لپ‌تاپ شخصی',
  whenYouClickContinueYouWillBePromptedTo:
    'با ادامه، دستگاه از شما می‌خواهد یک روش احراز هویت اضافه کنید.',
  ifYouDoNotWantToUseTheAuthenticator:
    'اگر نمی‌خواهید از روش پیشنهادی استفاده کنید، پنجره آن را ببندید تا روش بعدی نمایش داده شود.',
  thisPasskeyHasAlreadyBeenRegistered: 'این کلید عبور قبلاً ثبت شده است.',
  youCannotHaveMoreThan: 'حداکثر تعداد کلید عبور:',
  passkeys: 'کلید عبور',
  passkeyCreationCancelledDueToOneOfTheFollowing: 'ایجاد کلید عبور به یکی از دلایل زیر لغو شد:',
  cancelledByUser: 'لغو توسط کاربر',
  passkeyAlreadyExistsForTheProvidedAuthenticator: 'برای این روش احراز هویت، کلید عبور موجود است',
  exceededTimeout: 'مهلت انجام کار تمام شد',
  somethingWentWrongPleaseTryAgainOrContactSupport:
    'مشکلی پیش آمد. دوباره تلاش کنید یا با پشتیبانی تماس بگیرید.',
  '404NotFound': '۴۰۴ ـ صفحه پیدا نشد',
  oopsSomethingWentWrong: 'مشکلی پیش آمد',
  thePageYouAreLookingForWasMovedRemoved:
    'صفحه موردنظر پیدا نشد. ممکن است آدرس آن تغییر کرده یا حذف شده باشد.',
  '500InternalServerError': '۵۰۰ ـ خطای سرور',
  anUnexpectedErrorOccurred: 'خطای پیش‌بینی‌نشده‌ای رخ داد.',
  goBack: 'بازگشت',
  home: 'صفحه اصلی',
  dashboard: 'داشبورد',
  allReports: 'همه گزارش‌ها',
  raven: 'Raven',
  smartKycPlatform: 'سامانه هوشمند شناخت مشتری',
  logOut: 'خروج',
  searchByClientName: 'جست‌وجوی نام مشتری…',
  sortBy: 'مرتب‌سازی بر اساس',
  submissionDate: 'تاریخ ثبت',
  lastReview: 'آخرین بررسی',
  order: 'ترتیب',
  descending: '↓ نزولی',
  ascending: '↑ صعودی',
  sort: 'مرتب‌سازی',
  filter: 'فیلتر',
  riskLevelJustification: 'دلایل تعیین میزان ریسک',
  breakdownOfRiskFactors: 'جزئیات عوامل ریسک',
  relativeContributionOfEvidenceToTheAssessment: 'سهم نسبی شواهد در ارزیابی',
  riskEvidenceContributionChart: 'نمودار سهم شواهد در ریسک',
  high3UnitsMedium1InformationalAndDismissed0:
    'ریسک بالا: ۳ واحد؛ متوسط: ۱ واحد؛ موارد اطلاع‌رسانی و ردشده: صفر. درصدها سهم شواهد را نشان می‌دهند، نه احتمال وقوع.',
  noContributingRiskEvidenceRecordedNoPercentageHasBeen:
    'شواهد مؤثری بر ریسک ثبت نشده است؛ درصدی محاسبه نشده است.',
  whyThisRiskLevel: 'چرا این میزان ریسک؟',
  provisionalOfficerReviewRequired: 'موقت · نیازمند بررسی کارشناس',
  reviewedAssessment: 'ارزیابی بررسی‌شده',
  reviewedFindings: '◦ یافته‌های بررسی‌شده:',
  companyAndMemberExposureUseTheHighestSupportedSeverity:
    '◦ ریسک شرکت و اعضا بر اساس بالاترین شدتِ دارای شواهد تعیین می‌شود.',
  researchCompleted: 'جست‌وجو تکمیل شد.',
  someResearchCoverageIsInsufficientAcceptanceRemainsUnavailable:
    'پوشش برخی بررسی‌ها کافی نیست. هنوز امکان تأیید وجود ندارد.',
  policy: 'خط‌مشی',
  publicWebResearch: '· جست‌وجوی منابع عمومی وب',
  riskLevel: 'میزان ریسک:',
  notes: 'یادداشت‌ها',
  addYourNote: 'افزودن یادداشت',
  addedBy: 'ثبت‌کننده',
  on: 'در تاریخ',
  deleteNote: 'حذف یادداشت',
  newNote: 'یادداشت جدید',
  addAnything: 'یادداشت خود را بنویسید…',
  save: 'ذخیره',
  monthlyTotals: 'آمار ماهانه',
  noDataInThisPeriod: 'در این بازه اطلاعاتی وجود ندارد.',
  viewChartData: 'مشاهده داده‌های نمودار',
  reportRisksOverTimeSelectAPointToInspect:
    'ریسک گزارش‌ها در طول زمان؛ برای مشاهده موارد، یک نقطه را انتخاب کنید',
  report: 'گزارش',
  noGeneratedReportsYet: 'هنوز گزارشی تهیه نشده است',
  weCouldnTLoadThisInformation: 'اطلاعات بارگیری نشد.',
  tryAgain: 'تلاش دوباره',
  loading: 'در حال بارگیری…',
  previous: 'قبلی',
  next: 'بعدی',
  errorLoadingClients: 'مشتریان بارگیری نشدند',
  tryAgain2: 'تلاش دوباره',
  errorLoadingOwners: 'مالکان بارگیری نشدند',
  name: 'نام',
  createdAt: 'تاریخ ایجاد',
  searchOrganizationsByNameCountryOrOwner: 'جست‌وجوی سازمان بر اساس نام، کشور یا مالک…',
  clearFilters: 'پاک کردن فیلترها',
  errorLoadingOrganizations: 'سازمان‌ها بارگیری نشدند',
  inactive: 'غیرفعال',
  active: 'فعال',
  noOfficersFound: 'کارشناسی پیدا نشد',
  noOfficersMatchYourSearchCriteria: 'کارشناسی با این مشخصات پیدا نشد.',
  thereAreNoOfficersInYourOrganizationYet: 'هنوز کارشناسی به سازمان اضافه نشده است.',
  invitationResent: 'دعوت‌نامه دوباره ارسال شد',
  aNewInvitationEmailHasBeenSentToThe: 'دعوت‌نامه جدید برای عضو ارسال شد.',
  failedToResendInvitation: 'ارسال دوباره دعوت‌نامه انجام نشد',
  resendInvitationEmail: 'ارسال دوباره دعوت‌نامه',
  resend: 'ارسال دوباره',
  searchClientsByNameTypeIdOfficerOrRisk: 'جست‌وجوی مشتری بر اساس نام، نوع، شناسه، کارشناس یا ریسک…',
  organizationName: 'نام سازمان',
  owner: 'مالک',
  accountStatus: 'وضعیت حساب',
  searchOfficersByNameOrEmail: 'جست‌وجوی کارشناس با نام یا ایمیل…',
  role: 'نقش',
  allRoles: 'همه نقش‌ها',
  managerOfficer: 'مدیر کارشناسان',
  officer: 'کارشناس',
  kybOfficer: 'کارشناس اشخاص حقوقی',
  kycOfficer: 'کارشناس اشخاص حقیقی',
  searchOwnersByNameEmailOrOrganization: 'جست‌وجوی مالک با نام، ایمیل یا سازمان…',
  success: 'انجام شد',
  passkeyHasBeenUpdated: 'کلید عبور به‌روزرسانی شد',
  weAreUnableToUpdateThisPasskeyAtThe: 'به‌روزرسانی کلید عبور انجام نشد. کمی بعد دوباره تلاش کنید.',
  passkeyHasBeenRemoved: 'کلید عبور حذف شد',
  weAreUnableToRemoveThisPasskeyAtThe: 'حذف کلید عبور انجام نشد. کمی بعد دوباره تلاش کنید.',
  edit: 'ویرایش',
  updatePasskey: 'ویرایش کلید عبور',
  youAreCurrentlyUpdatingThe: 'در حال ویرایش',
  passkey2: 'کلید عبور',
  update: 'به‌روزرسانی',
  deletePasskey: 'حذف کلید عبور',
  areYouSureYouWantToRemoveThe: 'حذف شود؟',
  passkey3: 'کلید عبور',
  pendingInvitation: 'در انتظار پذیرش دعوت',
  errorLoadingOfficers: 'کارشناسان بارگیری نشدند',
  ownerName: 'نام مالک',
  organization: 'سازمان',
  noOwnersFound: 'مالکی پیدا نشد',
  noOwnersMatchYourSearchCriteria: 'مالکی با این مشخصات پیدا نشد.',
  thereAreNoOrganizationOwnersInTheSystemYet: 'هنوز مالکی در سامانه ثبت نشده است.',
  noClientsFound: 'مشتری پیدا نشد',
  noClientsMatchYourSearchCriteria: 'مشتری با این مشخصات پیدا نشد.',
  thereAreNoClientsAvailableAtTheMoment: 'در حال حاضر مشتری ثبت نشده است.',
  noOrganizationsFound: 'سازمانی پیدا نشد',
  noOrganizationsMatchYourSearchCriteria: 'سازمانی با این مشخصات پیدا نشد.',
  thereAreNoOrganizationsInTheSystemYet: 'هنوز سازمانی در سامانه ثبت نشده است.',
  created: 'ایجادشده',
  lastUsed: 'آخرین استفاده',
};
